import { render } from "./ContentPtBR.vue?vue&type=template&id=dcfdf588&scoped=true"
import script from "./ContentPtBR.vue?vue&type=script&lang=js"
export * from "./ContentPtBR.vue?vue&type=script&lang=js"

import "./ContentPtBR.vue?vue&type=style&index=0&id=dcfdf588&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcfdf588"]])

export default __exports__